import { queryOptions, useQuery } from '@tanstack/react-query';

import { menusApi } from '../api/menus-api';

import { menuKeys } from './menu-keys';

/** At most 20 menus per store, so the list is not paginated. */
export function menusQueryOptions(storeId: string) {
  return queryOptions({ queryKey: menuKeys.list(storeId), queryFn: () => menusApi.list(storeId) });
}

export function useMenus(storeId: string) {
  return useQuery(menusQueryOptions(storeId));
}
